<script>
    import { onMount } from "svelte";
    import { createEventDispatcher } from 'svelte';
    import { CheeseTypeStore, LocationStore, Authentication } from '../stores'
    
    const dispatch = createEventDispatcher();

    let addStep = 0;
    let cheeseCount = 0;
    let value;
    let shown = false;
    let authenthicationData = '';
    let cheeseTypesDropDown = [{ id: "0", text: "Loading ..." }];
    let cheeseTypesDropDownSelected;
    //let cheeseTypeDropdownSelectedId = 0;
    let cheeseCreationDate;
    let locationsDropDown = [{ id: "0", text: "Loading ..." }];
    let locationsDropDownSelected;
    //let locationDropdownSelectedId = 0;
    let locationPositions = [];
    let cheeseRemark = '';

    onMount(async function () {
        loadCheeseTypes();
        loadLocations();

        // Set current Day as creation-date
        let now = new Date(), month, day, year;
        month = '' + (now.getMonth() + 1),
        day = '' + now.getDate(),
        year = now.getFullYear();
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
        cheeseCreationDate = [year, month, day].join('-');
    });

    async function loadCheeseTypes() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/cheesetype';

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        // Put the data in the store
        CheeseTypeStore.set(data);

        var arrayLength = data.length;
        if(arrayLength > 0) {
            cheeseTypesDropDown = [];
            for (var i = 0; i < arrayLength; i++) {
                cheeseTypesDropDown.push({id: data[i].id, text: data[i].name});
            }
            //cheeseTypesDropDownSelected = data[0];
        }
    }

    async function loadLocations() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/location';

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        // Put the data in the store
        LocationStore.set(data);

        var arrayLength = data.length;
        if(arrayLength > 0) {
            locationsDropDown = [];
            for (var i = 0; i < arrayLength; i++) {
                locationsDropDown.push({id: data[i].id, text: data[i].name});
            }
            //locationsDropDownSelected = data[0];
        }
    }

    async function loadLocationsAvailable() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/Location_available/' + locationsDropDownSelected.id;

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        locationPositions = data;
    }

    export function show() {
        addStep = 0;
        cheeseCount = 0;
        nextButtonDisabled = false;
        locationPositions = [];
        cheeseRemark = '';
        cheeseTypesDropDownSelected = '';
        locationsDropDownSelected = '';
        shown = true;
    }
    function hide() {
        shown = false;
    }

    let onChange = () => {};
    
    function _onNextClick() {
        if(addStep === 0 && cheeseCount === 0) {
            _onCancel();
            return;
        }
        // Cheese-Type OR Positions-Selected
        if(addStep === 0 || addStep === 2) {
            nextButtonDisabled = true;
        }

        addStep = addStep + 1
    }

    async function _onOkay() {
        await Authentication.subscribe((data) => authenthicationData = data);

        let method = 'POST';

        var newCheeseList = [];
        while(cheeseCount > 0) {
            var newCheese = {id: 0, cheeseTypeId: 0, locationId: 0, locationLevel: 0, locationLevelPosition: 0, remark: '', creationDate: null, creationWeight: 0, soldWeight: 0, price: 0, sold: false};
            newCheese.locationId = locationsDropDownSelected.id;
            newCheese.cheeseTypeId = cheeseTypesDropDownSelected.id;
            newCheese.remark = cheeseRemark;
            newCheese.creationDate = cheeseCreationDate;

            // Now get first selected level and levelposition
            var positionFound = false;
            var locationPositionLength = locationPositions.length;
            for (var i = 0; i < locationPositionLength; i++) {
                var positionLength = locationPositions[i].length;
                for (var j = 0; j < positionLength; j++) {
                    if (locationPositions[i][j].inUse === true && locationPositions[i][j].selectable === true) {
                        newCheese.locationLevel = i + 1;
                        newCheese.locationLevelPosition = locationPositions[i][j].pos;
                        locationPositions[i][j].selectable = false;
                        positionFound = true;
                        break;
                    }
                }

                if(positionFound === true) {
                    break;
                }
            }

            newCheeseList.push(newCheese);

            cheeseCount = cheeseCount - 1;
        }
        /*cheeseType.maturationDays = parseInt(cheeseType.maturationDays);
        cheeseType.pricePerKiloGram = parseFloat(String(cheeseType.pricePerKiloGram).replace(',', '.'));
        cheeseType.weigthLosPercent = parseFloat(String(cheeseType.weigthLosPercent).replace(',', '.'));*/

        const response = await fetch(
            'MYURL/CheeseList',
            {
                method: method,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
                body: JSON.stringify(
                    newCheeseList
                )
            }
        );
        const data = await response.json();

        dispatch('accepted', {
            
        });

        _onCancel();
    }

    let nextButtonDisabled = false;
    function _enableNextButton() {
        nextButtonDisabled = false;
    }

	function datepicked (e) {
        _enableNextButton();
	}
    
    function _onCancel() {
        hide();
    }

    function _locationPositionChanged() {
        var selectedCnt = 0;
        var locationPositionLength = locationPositions.length;
        for (var i = 0; i < locationPositionLength; i++) {
            var positionLength = locationPositions[i].length;
            for (var j = 0; j < positionLength; j++) {
                if (locationPositions[i][j].inUse === true && locationPositions[i][j].selectable === true) {
                    selectedCnt++;
                }
            }
        }

        if(selectedCnt === cheeseCount) {
            nextButtonDisabled = false;
        }
        else {
            nextButtonDisabled = true;
        }
    }

    function _showLocationPositions() {
        loadLocationsAvailable();
    }
    
    $: onChange(value)
</script>

<svelte:window on:keydown={(e) => {
    if(e.keyCode == 27) {
        hide();
    }
}} />
{#if shown}
    <div class="cruCheeseType">
        <div class="modal">
            <span class="close" on:click={() => hide()}>&times</span>

            {#if addStep === 0}
                <h2>Anzahl neuer Käse</h2>
                <input class="textbox" type=number bind:value={cheeseCount} />
            {/if}
            {#if addStep === 1}
                <h2>Welcher Käse-Typ</h2>
                <select class="textbox" bind:value={cheeseTypesDropDownSelected} on:change="{() => _enableNextButton()}">
                    {#each cheeseTypesDropDown as cheeseTypesDropDownItem}
                        <option value={cheeseTypesDropDownItem}>
                            {cheeseTypesDropDownItem.text}
                        </option>
                    {/each}
                </select>
            {/if}
            {#if addStep === 2}
                <h2>Erstellungsdatum</h2>
                <input type="date" bind:value={cheeseCreationDate} on:datepicked={datepicked}/>
            {/if}
            {#if addStep === 3}
            <h2>Schrank und Positionen auswählen</h2>
            <select class="textbox" bind:value={locationsDropDownSelected} on:change="{() => _showLocationPositions()}">
                {#each locationsDropDown as locationsDropDownItem}
                    <option value={locationsDropDownItem}>
                        {locationsDropDownItem.text}
                    </option>
                {/each}
            </select>
            <div class="wrapper">
                {#each locationPositions as location, locationIndex}
                    {#each location as position, positionIndex}
                        <label>
                            <input type=checkbox bind:checked={position.inUse} disabled={!position.selectable} on:change={_locationPositionChanged}>
                            Etage:&nbsp;{locationIndex + 1}&nbsp;Position:&nbsp;{positionIndex + 1}
                        </label>
                    {/each}
                {/each}
            </div>
            {/if}
            {#if addStep === 4}
                <h2>Globaler Kommentar/Bemerkung</h2>
                <textarea class="textboxMultiLine" bind:value={cheeseRemark} />
            {/if}
            
            <div>
                <div class="buttons">
                    {#if addStep < 4}
                        <button disabled={nextButtonDisabled} on:click={() => _onNextClick()}>
                            Weiter
                        </button>
                    {:else}
                        <button on:click={() => _onOkay()}>
                            Speichern
                        </button>
                    {/if}
                    <button on:click={() => _onCancel()}>
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}


<style>
    .textboxMultiLine {
        padding-top: -10px;
        margin-top: -10px;
        min-width: 500px;
        min-height: 100px;
    }

    .wrapper{
        padding:20px;
        max-height: 320px;
        overflow-y: scroll;
    }

    .textbox {
        padding-top: -10px;
        margin-top: -10px;
        min-width: 500px;
    }

    .buttons {
        float: right;
    }

	.cruCheeseType {
	  background: rgb(0, 0, 0);
	  background: rgba(0, 0, 0, 0.6);
      position: fixed;
      width: 88%;
      height: 100%;
      top: 0;
      left: 0;

	  padding: 3rem 7.5rem;
	  display: flex;
	  flex-direction: column;
	}

    .modal {
        background-color: white;
        max-width: 80vw;
        padding: 1em;
        margin: -30px auto;
    }

    .close {
        cursor: pointer;
        float: right;
    }
    .close:hover {
        font-weight: bold;
    }
  
    @media only screen and (max-width: 767px) {
        .cruCheeseType {
            background: rgb(0, 0, 0);
            background: rgba(0, 0, 0, 0.6);
            position: fixed;
            width: 98%;
            height: 100%;
            top: 0;
            left: 0;

            padding: 3rem 1%;
            display: flex;
            flex-direction: column;
        }
        
        .textbox {
            padding-top: -10px;
            margin-top: -10px;
            min-width: 320px;
        }
        
        .textboxMultiLine {
            padding-top: -10px;
            margin-top: -10px;
            min-width: 320px;
            min-height: 100px;
        }
    }
</style>